import LangEnum from '../../../../../lang/LangEnum';
import { LangEnumOption } from '../../../../business-policies/business-policy.options';
import { Role } from '../../../../orders/actions/types/actions.types';

export enum RolesToHideOrderObservationEnum {
  CUSTOMER = 'customer',
  REPRESENTATIVE = 'representative',
}

export const orderObservationRolesOptions: LangEnumOption[] = [
  {
    value: RolesToHideOrderObservationEnum.REPRESENTATIVE,
    label: LangEnum.GLOBAL_SALES_REPRESENTATIVES,
  },
  {
    value: RolesToHideOrderObservationEnum.CUSTOMER,
    label: LangEnum.GLOBAL_CUSTOMER,
  },
];

export const mapRolesToHideOrderObservationToBackend = (values: string[]): Role[] => {
  const roles: Role[] = [];
  if (values.includes(RolesToHideOrderObservationEnum.CUSTOMER)) {
    roles.push(Role.COMPRADOR, Role.ADMIN_LOJA);
  }
  if (values.includes(RolesToHideOrderObservationEnum.REPRESENTATIVE)) {
    roles.push(Role.VENDEDOR);
  }
  return roles;
};

export const mapRolesToHideOrderObservationFromBackend = (
  roles: Role[],
): RolesToHideOrderObservationEnum[] => {
  const values: RolesToHideOrderObservationEnum[] = [];
  if (roles.some((role) => role === Role.COMPRADOR || role === Role.ADMIN_LOJA)) {
    values.push(RolesToHideOrderObservationEnum.CUSTOMER);
  }
  if (roles.includes(Role.VENDEDOR)) {
    values.push(RolesToHideOrderObservationEnum.REPRESENTATIVE);
  }
  return values;
};
